var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 21.6a4.005 4.005 0 0 1-4.001-4V7.2h-.8a.799.799 0 1 1 0-1.6h2.48a4.007 4.007 0 0 1 3.92-3.2h1.6a4.009 4.009 0 0 1 3.92 3.2h2.48a.8.8 0 1 1 0 1.6h-.8v10.4a4.006 4.006 0 0 1-4 4h-4.8zm-2.401-4a2.4 2.4 0 0 0 2.4 2.4h4.8c1.326 0 2.4-1.074 2.4-2.4V7.2h-9.6v10.4zm1.736-12h6.127A2.404 2.404 0 0 0 12.799 4h-1.6a2.407 2.407 0 0 0-2.264 1.6zM12.8 16v-4.8a.8.8 0 1 1 1.6 0V16a.799.799 0 1 1-1.6 0zm-3.2 0v-4.8a.8.8 0 0 1 1.6 0V16a.8.8 0 0 1-1.6 0z",
    fill: "#161338"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c08d2fe9f453c813bd9da426357ae8e6.svg";
export { ForwardRef as ReactComponent };